import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  background-color: transparent; \n  border-top: ",
        ";\n  height: ",
        ";\n  display: none;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center; \n\n\n\n\n  ",
        " {\n    display: flex; \n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin: auto; \n  width: 100%; \n  @media (min-width: 768px) {\n    width: 90%; \n  @media (min-width: 1208px) {\n    width: 80%; \n    }\n  @media (min-width: 1600px) {\n    width: 70%; \n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\nmargin-right: 1rem; \n@media (min-width: 1000px) {\n  margin-right: 0rem; \n}\n &:hover {\n  opacity: 0.8;\n }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  color: #0154FD;\n  width: 28px;\n  height: 28px; \n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import styled from "styled-components";
import { Flex, useMatchBreakpoints, Text } from "@pancakeswap/uikit";
import Link from "next/link";
import { useTranslation } from "@pancakeswap/localization";
import { AiOutlineContainer } from "@react-icons/all-files/ai/AiOutlineContainer";
var Wrapper = /*#__PURE__*/ memo(styled.div.withConfig({
    componentId: "sc-aac936e6-0"
})(_templateObject(), function(param) {
    var showBorderTop = param.showBorderTop;
    return showBorderTop ? "1px solid #fff" : "none";
}, function(param) {
    var $isSide = param.$isSide;
    return $isSide ? "100%" : "auto";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}));
var FlexStyled = styled(Flex).withConfig({
    componentId: "sc-aac936e6-1"
})(_templateObject1());
var LinkStyled = styled(Link).withConfig({
    componentId: "sc-aac936e6-2"
})(_templateObject2());
var DocsIcon = styled(AiOutlineContainer).withConfig({
    componentId: "sc-aac936e6-3"
})(_templateObject3());
var Footer = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    var t = useTranslation().t;
    var ref = useMatchBreakpoints(), isTablet = ref.isTablet, isMobile = ref.isMobile;
    var isSide = variant === "side";
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Wrapper, {
            $isSide: isSide,
            children: /*#__PURE__*/ _jsx(Flex, {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                children: /*#__PURE__*/ _jsx(Text, {
                    fontSize: "14px",
                    fontWeight: "500",
                    textAlign: "center",
                    marginTop: "2rem",
                    children: "BaseSwap is an independent project and has no official connection to Coinbase, Base or any Coinbase entity."
                })
            })
        })
    });
};
export default /*#__PURE__*/ memo(Footer);
